export {default as CoachAcceleratorBonusBanner} from './CoachAcceleratorBonusBanner.connect';
